<template>
  <div class="dashboard-block">
    <h2>App Version</h2>

    <form>
      <div class="row row-clear-md-4">
        <div class="col-md-4">
          <div :class="['form-group', errorClass('ios_minimum_version')]">
            <label class="control-label">iOS Minimum Version</label>
            <input
              name="ios_minimum_version"
              type="text"
              class="form-control"
              v-model="stateIosMinimumVersion">

            <help-block field="ios_minimum_version"/>
          </div>
        </div>
        <div class="col-md-4">
          <div :class="['form-group', errorClass('android_minimum_version')]">
            <label class="control-label">Android Minimum Version</label>
            <input
              name="android_minimum_version"
              type="text"
              class="form-control"
              v-model="stateAndroidMinimumVersion">

            <help-block field="android_minimum_version"/>
          </div>
        </div>
        <div class="col-md-4">
          <div :class="['form-group', errorClass('app_minimum_version')]">
            <label class="control-label">App Minimum Version</label>
            <input
              name="app_minimum_version"
              type="text"
              class="form-control"
              v-model="stateAppMinimumVersion">

            <help-block field="app_minimum_version"/>
          </div>
        </div>
      </div>

      <ladda-button
        class="btn btn-success"
        :click="handleSaveAppVersionSettings">
        <i class="fa fa-check"></i> Save Changes
      </ladda-button>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { stateMapper } from 'mixins/settings'
import { pick } from 'lodash'

export default {
  mixins: [stateMapper],

  methods: {
    ...mapActions('settings', ['updateSettings']),

    handleSaveAppVersionSettings () {
      return this.validate()
        .then(() => {
          return this.updateSettings(pick(this.settings, [
            'ios_minimum_version',
            'android_minimum_version',
            'app_minimum_version'
          ]))
        })
    }
  }
}
</script>
